import React, { useEffect } from "react";
import { connect } from "react-redux";

import { RouteComponentProps } from "react-router-dom";

import { LoadingSpinner } from "@mapmycustomers/ui";

import { exchangeAuthorizationCode } from "@app/store/auth/actions";

export interface AuthCallbackPageProps extends RouteComponentProps {}

export const AuthCallbackPage = ({
  location,
  onExchangeAuthorizationCode,
}: AuthCallbackPageProps & typeof mapDispatchToProps) => {
  useEffect(() => {
    onExchangeAuthorizationCode(location.search);
  }, [location.search, onExchangeAuthorizationCode]);

  return <LoadingSpinner global />;
};

const mapDispatchToProps = {
  onExchangeAuthorizationCode: exchangeAuthorizationCode,
};

export default connect(null, mapDispatchToProps)(AuthCallbackPage);
